import React, { useEffect, useState } from 'react'
import AppLayout from '../../../../layout/components/AppLayout'
import useSystemMasterList from '../../../../hooks/useSystemMasterList'
import NotesForm from '../components/NotesForm'
import notesServices from '../notesServices';
import NotesGroupForm from '../components/NotesGroupForm';
import NoteGroupList from '../components/NoteGroupList';

function NotesDashboardPage() {

  const [notesGroupList,setNotesGroupList]  = useState(null);
  const [notesListByGroup,setNotesListByGroup]  = useState(null);


  const getNotesGroupList = () =>{
    notesServices.getGroupList().then(res=>{
      console.log(res);
      setNotesGroupList(res.data);
    }).catch(error=>{
      console.log(error)
    })
  }

  const getNotesListByGroup = () =>{
    notesServices.getByGroup().then(res=>{
      console.log(res.data);
      setNotesListByGroup(res.data);
    }).catch(error=>{
      console.log(error)
    })
  }



  useEffect(()=>{
    getNotesListByGroup();
    getNotesGroupList();
  },[])

  

  return (
    <AppLayout>
        <div className='container-fluid'>
          <div className='row'>
            <div className='col-md-12'>
              {notesGroupList && <NotesForm notesGroupList={notesGroupList} callBack={getNotesListByGroup} /> }
              <span className='float-end'>
              {notesGroupList && <NotesGroupForm callBack={getNotesGroupList} /> }
              {notesGroupList && <NoteGroupList notesGroupList={notesGroupList} callBack={getNotesGroupList} /> }
              </span>
            </div>
          </div>

          <div className='row'>
            <div className='col-md-12 bg-white text-dark'>
              

            </div>
          </div>

          <div className='row'>
            {notesListByGroup && notesListByGroup.map(notesGroup=>{
                if(notesGroup.notesList.length > 0){
                  return(
                    <div className='col-md-3'>
                      <div className="card mb-2 bg-dark text-white border-primary">
                        <div className="card-header border-primary text-info bg-dark">{notesGroup.title} ({notesGroup.notesList.length}) </div>
                        <div className="card-body p-0">
                          {notesGroup.notesList.map(notes=>
                            <NotesForm key={notes.id} notesGroupList={notesGroupList} callBack={getNotesListByGroup} data={notes} />
                          )}
                        </div>
                      </div>
                    </div>
                  )
                }
            })}
          </div>
        </div>
        
    </AppLayout>
  )
}

export default NotesDashboardPage